import script from "./aide-fixed.vue?vue&type=script&lang=ts&setup=true"
export * from "./aide-fixed.vue?vue&type=script&lang=ts&setup=true"

import "./aide-fixed.vue?vue&type=style&index=0&id=c5af38ee&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5af38ee"]])

export default __exports__